import { useEffect, useState } from 'react'

import type { IAgoraRTCRemoteUser } from 'agora-rtc-sdk-ng'

import { useAgoraRTCClientContext } from '@core/agoraRTC/contexts/AgoraRTCClientContext'
import { logError } from '@core/logging'

export interface useRemoteUsersProps {
  logMultipleRemoteUsersError?: boolean
  channel?: string
}

/**
 * Hook that detects remote user changes and returns the remote users
 */
export function useRemoteUsers({
  logMultipleRemoteUsersError,
  channel,
}: useRemoteUsersProps): IAgoraRTCRemoteUser[] {
  const client = useAgoraRTCClientContext()

  const [remoteUsers, setRemoteUsers] = useState<IAgoraRTCRemoteUser[]>(
    client?.remoteUsers ?? [],
  )
  useEffect(() => {
    client?.onRemoteUserChange(() => {
      setRemoteUsers([...client.remoteUsers])
    })

    if (
      logMultipleRemoteUsersError &&
      remoteUsers.length &&
      remoteUsers.length > 1
    ) {
      logError(new Error('More than one remote user is detected.'), {
        data: {
          channel,
        },
      })
    }
  }, [channel, client, logMultipleRemoteUsersError, remoteUsers.length])

  return remoteUsers
}
